export const EVENT_SEARCH_MODAL_OPENING: string = "search-modal:open";
export const EVENT_SEARCH_MODAL_CLOSING: string = "search-modal:close";
export const EVENT_SEARCH_MODAL_USERINPUT: string = "search-modal:input";
export const EVENT_SEARCH_MODAL_FINALIZED_INPUT: string =
  "search-modal:finalize-input";
export const EVENT_SEARCH_SURPRISE_ME: string =
  "search-modal:surprise-me-launch";
export const EVENT_SEARCH_MODAL_LOADING: string = "search-modal:loading";
export const ITEMS_PER_PAGE: number = 24;

export const SEARCH_MODAL_HISTORY_KEY: string = "search-modal__history";
export const SEARCH_MODAL_PREFETCH_KEY: string = "search-modal__prefetch";

export const CATEGORY_VALUES: string[] = [
  "all",
  "video-slots",
  "live-dealer",
  "originals",
] as const;

export const ORIGINALS_MENU_ITEM_BY_BRAND: Record<string, string> = {
  bitcasino: "bitcasino-originals",
  sportsbet: "sportsbet-originals",
};

export const HIDDEN_PROVIDERS: string[] = ["oddin"];
